import { apiStringFieldMaxLength, apiVersions } from './ApiVersions';
import analytics from './Analytics';
import taskUrls from './TaskUrls';
import formOptions from './FormOptions';
import general from './General';

const chargingModel = {
  DEBT: 'DEBT',
  CRED: 'CRED',
  SHAR: 'SHAR',
};

const whoPaysMapping = [
  {
    id: chargingModel.DEBT,
    type: 'paid by you',
  },
  {
    id: chargingModel.CRED,
    type: 'paid by payee',
  },
  {
    id: chargingModel.SHAR,
    type: 'shared',
  },
];

const config = {
  analytics,
  apiStringFieldMaxLength,
  apiVersions,
  taskUrls: taskUrls(),
  productData: {},
  ...formOptions,
  ...general,
  whoPaysMapping: whoPaysMapping,
  chargingModel,
};

export default config;
